import { ReactNode } from "react";
import { useFeedback } from "@/dashboard/store/store";
import { useAuth } from "@/auth/hooks/useAuth";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

export default function ErrorBoundaryWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const { visibleFeedback, setVisibleFeedback, setErrorLog } = useFeedback();
  const { loading, user } = useAuth();
  const location = useLocation();
  const resetKey = [
    location.pathname,
    location.search,
    loading ? "loading" : "ready",
    user?.id ?? "anonymous",
    Array.isArray(user?.roles) ? user.roles.join(",") : "",
  ].join("|");

  return (
    <ErrorBoundary
      resetKey={resetKey}
      visibleFeedback={visibleFeedback}
      setVisibleFeedback={setVisibleFeedback}
      setErrorLog={setErrorLog}
    >
      {children}
    </ErrorBoundary>
  );
}
